import React from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import AuthProvider from "src/context/AuthContext/AuthProvider";
import useAuth from "src/context/AuthContext/useAuth";
import Layout from "src/components/Layout";
import Dashboard from "src/pages/Dashboard";
import Endpoints from "src/pages/Endpoints";
import Logs from "src/pages/Logs";
import Settings from "src/pages/Settings";
import CallEngine from "src/pages/CallEngine";
import Docs from "src/pages/Docs";
import Login from "src/pages/Login";

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoggedIn, userLoading } = useAuth();
  if (userLoading) return null;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const Root: React.FC = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

const AuthedLayout = (
  <RequireAuth>
    <Layout />
  </RequireAuth>
);

export const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/",
        element: AuthedLayout,
        children: [
          { index: true, element: <Dashboard /> },
          { path: "endpoints", element: <Endpoints /> },
          { path: "logs", element: <Logs /> },
          { path: "call-engine", element: <CallEngine /> },
          { path: "settings", element: <Settings /> },
          { path: "documentation", element: <Docs /> },
        ],
      },
      // Company-scoped documentation URL: /c/<connectorId>/documentation
      {
        path: "/c/:connectorId",
        element: AuthedLayout,
        children: [
          { path: "documentation", element: <Docs /> },
        ],
      },
    ],
  },
]);
